<div
  class="column twelve confirmation-link-area-wrapper"
  [class.ca-mileage-confirmation-btn-wrapper]="btnWrapper"
  [class.has-divider]="hasDivider"
>
  <ng-content></ng-content>
</div>
